export const ActionTypes = {
  REQUEST: "ADMIN_FETCH_USER_TYPES_REQUEST",
  SUCCESS: "ADMIN_FETCH_USER_TYPES_SUCCESS",
  FAILURE: "ADMIN_FETCH_USER_TYPES_FAILURE",

  SUCCESS_SINGLE: "ADMIN_FETCH_USER_TYPE_SUCCESS",
  UPDATE_SUCCESS: "ADMIN_UPDATE_USER_TYPE_SUCCESS",
  CREATE_SUCCESS: "ADMIN_CREATE_USER_TYPE_SUCCESS",
  DELETE_SUCCESS: "ADMIN_DELETE_USER_TYPE_SUCCESS",
}

export interface IUserType {
  id: number;
  is_auto_populate: boolean;
  is_default: boolean;
  is_visible: boolean;
  name: string;
}

interface NormalizedEntities {
  [key: string]: IUserType;
}

export interface IState {
  entities: NormalizedEntities;
  ids: string[];
  count: number;
  loading: boolean;
  error: any;
}